import React, { useState } from "react";

import { Container } from "@components/Container/Container";
import styles from "./styles.module.scss";
import { Box } from "@components/Box/Box";
import { Heading } from "@components/Heading/Heading";
import { ImageField } from "@helpers/interfaces/image";
import { AspectRatio } from "@components/AspectRatio/AspectRatio";
import { Button } from "@components/Button/Button";
import anime from "animejs";
import { Link } from "@components/Link/Link";
import classnames from "classnames";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";

async function initializeScrollTo(ref: HTMLElement) {
  const { scrollTo } = await import("../../js/dom/scrollTo.js");
  scrollTo(ref, 500);
}

export interface BreadcrumbProps {
  Name: string;
  Url: string;
}
export interface ArticleHeroProps {
  Breadcrumb: BreadcrumbProps[];
  Headline?: string;
  BodyText?: string;
  HeroImage?: ImageField;
  HeroImageBackgroundBlack?: boolean;
  Filters: {
    Tag: string;
    Title: string;
    Key: string;
  }[];
}

const ArticleHero: React.FC<ArticleHeroProps> = ({
  Breadcrumb,
  Headline,
  BodyText,
  HeroImage,
  HeroImageBackgroundBlack,
  Filters
}) => {
  const [selectedKey, setSelectedKey] = useState<string>(".");

  const selectFilter = (key: string): void => {
    if (key !== "") {
      const sectionItems = document.querySelectorAll(
        `.sectionpage-container:not([id='${key}'])`
      );
      setSelectedKey(key);
      anime({
        targets: sectionItems,
        height: 0,
        translateY: -60,
        opacity: 0,
        duration: 200,
        easing: "easeOutQuart",
        complete: event => {
          event.animatables.map(el => {
            return (el.target.style.pointerEvents = "none");
          });
        }
      });
      const keyDiv = document.getElementById(key) as HTMLElement;
      anime({
        targets: keyDiv,
        translateY: 0,
        opacity: 1,
        height: keyDiv.querySelector("div")?.scrollHeight,
        duration: 200,
        easing: "easeOutQuart",
        complete: event => {
          initializeScrollTo(keyDiv);
          event.animatables.map(el => {
            el.target.style.pointerEvents = "";
            el.target.style.height = "";
            return true;
          });
        }
      });
    } else {
      setSelectedKey("");

      anime({
        targets: ".sectionpage-container",
        translateY: 0,
        height: (_el: HTMLDivElement) => _el.querySelector("div")?.scrollHeight,
        opacity: 1,
        duration: 200,
        easing: "easeOutQuart",
        complete: event => {
          event.animatables.map(el => {
            el.target.style.pointerEvents = "";
            el.target.style.height = "";
            return true;
          });
        }
      });
    }
  };

  return (
    <Box className={styles.articleHero}>
      <Container inside>
        <Box className={styles.articleHeroText}>
          <span
            dangerouslySetInnerHTML={{ __html: `<!-- content end -->` }}
          ></span>
          {/* {Breadcrumb && (
            <Box as="ul" className={styles.breadcrumb}>
              {Breadcrumb.map((bread: BreadcrumbProps, index: number) => {
                return (
                  <Box as="li" key={`breadcrum_${index}`}>
                    {bread.Url && index < Breadcrumb.length - 1 && index > 0 ? (
                      <Link href={bread.Url}>{bread.Name}</Link>
                    ) : (
                      <span>{bread.Name}</span>
                    )}
                  </Box>
                );
              })}
            </Box>
          )} */}
          <span
            dangerouslySetInnerHTML={{ __html: `<!-- content begin -->` }}
          ></span>
          {!HeroImage && Headline && (
            <Heading as="h1" className={styles.heading}>
              {Headline}
            </Heading>
          )}
          {!HeroImage && BodyText && (
            <Box
              className={classnames(
                styles.paragraphText,
                styles.paragraphTextNoImage
              )}
              dangerouslySetInnerHTML={{ __html: BodyText }}
            />
          )}
        </Box>

        {HeroImage && (
          <Box className={styles.heroImageContainer}>
            <Box className={styles.heroImageContentWrapper}>
              <Box
                className={classnames(
                  styles.articleHeroText,
                  styles.heroImageContent,
                  HeroImageBackgroundBlack && styles.heroImageContentBlack
                )}
              >
                {Headline && (
                  <Heading as="h1" className={styles.heading}>
                    {Headline}
                  </Heading>
                )}
                {BodyText && (
                  <Box
                    className={classnames(styles.paragraphText)}
                    dangerouslySetInnerHTML={{ __html: BodyText }}
                  />
                )}
              </Box>
              <AspectRatio ratio={["16:9", "2644:1320"]} className="heroRatio">
                <UmbracoImage
                  image={HeroImage}
                  width={[375, 537, 950, 1322]}
                  height={[210, 268, 474, 660]}
                  isCover
                  params={{ mode: "crop" }}
                  removeLazyLoad
                />
              </AspectRatio>
            </Box>
          </Box>
        )}

        {Filters && (
          <Box as="ul" className={styles.filterlist}>
            <Box as="li">
              <Button
                variant={selectedKey === "" ? "filter-selected" : "filter"}
                onClick={() => selectFilter("")}
              >
                Alle
              </Button>
            </Box>
            {Filters.map(filte => {
              if (filte.Title === "") {
                return null;
              }
              return (
                <Box as="li" key={filte.Key}>
                  <Button
                    variant={
                      selectedKey === filte.Key ? "filter-selected" : "filter"
                    }
                    onClick={() => selectFilter(filte.Key)}
                  >
                    {filte.Title}
                  </Button>
                </Box>
              );
            })}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export { ArticleHero };
